module.exports = __webpack_public_path__ + "media/country_flags/kn-0a2f23f7.png";